import axios from 'axios';

export const restoreReq = async (phone: string) => {
  const resp = await axios.post(`/restore`, JSON.stringify({ phone }), {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return resp.data;
};

export const restoreComplete = async (code: string, password: string, phone: string) => {
  const resp = await axios.patch(
    '/api/v1/restore-complete',
    JSON.stringify({
      code,
      password,
      phone,
    }),
    {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    },
  );

  return resp.data;
};
